module.exports = __webpack_public_path__ + "static/media/coffee_open_graph.9506bf2f.jpg";